import React from 'react';
import './WhyUs.css';

const REASONS = [
  {
    icon: '🏥',
    title: 'Healthcare-First Approach',
    desc:  'Deep understanding of clinical ecosystems and medical nuances.',
  },
  {
    icon: '📊',
    title: 'Strategy-Led Execution',
    desc:  'Not just ideas — measurable outcomes you can report on.',
  },
  {
    icon: '🎯',
    title: 'Targeted Engagement',
    desc:  'Reach the right audience, not just more audience.',
  },
  {
    icon: '🔗',
    title: 'Integrated Solutions',
    desc:  'Seamless blend of digital, on-ground, and medical.',
  },
];

function WhyUs() {
  return (
    <section className="section-padding">
      <div className="container">
        <h2 className="section-title reveal">Why Choose Us</h2>

        <div className="whyus__grid">
          {REASONS.map(({ icon, title, desc }) => (
            <div className="whyus__card reveal" key={title}>
              <div className="whyus__icon">{icon}</div>
              <strong className="whyus__title">{title}</strong>
              <p className="whyus__desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
